import CreateClassIcon from './component.jsx'
export default CreateClassIcon
